import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from 'src/components/Home';
import Welcome from 'src/components/Welcome';

import ProxyUsers from 'src/components/proxys/ProxyUsers';
import ProxyRoles from 'src/components/proxys/ProxyRoles';
import ProxyTokens from 'src/components/proxys/ProxyTokens';
import ProxyExistencias from 'src/components/proxys/ProxyExistencias';
import ProxyOrders from 'src/components/proxys/ProxyOrders';
import ProxyInternalOrders from 'src/components/proxys/ProxyInternalOrders';

function App() {
  const baseRoute = "/";

  return (
      <BrowserRouter>
        <Routes>
          <Route path={baseRoute} element={<Home />}>
            <Route index element={<Welcome />} />
            <Route path="AdministracionRoles" element={<ProxyRoles />} />
            <Route path="AdministracionUsuarios" element={<ProxyUsers />} />
            <Route path="AdministracionTokens" element={<ProxyTokens />} />
            <Route path="Existencias" element={<ProxyExistencias />} />
            <Route path="Pedidos" element={<ProxyOrders />} />
            <Route path="PedidosInternos" element={<ProxyInternalOrders />} />
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
